import logo from './logo.svg';
import './App.css';
import Home from './components/UI/Home';
import Value from './components/UI/Value';
import FeaturedProduct from './components/UI/FeaturedProduct';
import Recognized from './components/UI/Recognized';
import Footer from './components/UI/Footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import About from './components/Pages/About';
import Main from './components/UI/Main';
import OurProjects from './components/Pages/OurProjects';

function App() {
  return (
    <BrowserRouter>
<ScrollToTop
/>
<Routes>
<Route path="/" element={<Main/>}>
</Route>
<Route path="about"element={<About/>}/>
<Route path="projects"element={<OurProjects/>}/>
</Routes>
</BrowserRouter>
  );
}

export default App;
